
    import Vue from "vue";
    import Component from "vue-class-component";
    import * as toastr from "toastr";
    import ApiClient from "@/utilities/ApiClient";
    import Utils from "@/utilities/Utils";
    import ApiButton from "@/vue/components/ApiButton.vue";
    import PrimaryButton from "@/vue/components/PrimaryButton.vue";
    import ConfirmDialogue from "@/vue/components/ConfirmDialogue.vue";
    import VisitViewHeader from "@/vue/components/VisitViewHeader.vue";
    import VisitViewDetail from "@/vue/components/VisitViewDetail.vue";
    import { IVisitSearchResult, VisitSearchResult } from "@/model/VisitSearchResult";
    import { IVisit } from "@/model/Visit";

    import { ILookupItem } from "@/model/LookupItem";

    @Component({ components: { ApiButton, PrimaryButton, ConfirmDialogue, VisitViewHeader, VisitViewDetail } })
    export default class VisitDialogue extends Vue {

        async mounted(): Promise<void> {
            // maybe this could be passed in from visits.vue?
            const loadVisitorCompanies = async () => { this.visitorCompanyList = await ApiClient.get("/api/visitorCompany/lookups"); }
            const loadRecipients = async () => { this.recipientList = await ApiClient.get(`/api/siteRecipient/lookups?siteID=${Utils.emptyGuidValue}`); }
            await Promise.all([
                loadVisitorCompanies(),
                loadRecipients()
            ]);
        }

        shouldShowDialogue: boolean = false;
        visitorCompanyList: Array<ILookupItem> = [];
        recipientList: Array<ILookupItem> = [];
        searchResult: VisitSearchResult = new VisitSearchResult();

        get emailButtonText() : string {
            return Utils.hasDateValue(this.searchResult.visit.completed)
                ? "Re-send results..."
                : "Re-send link...";
        }

        async show(result: IVisitSearchResult): Promise<void> {
            Utils.resetObject(this.searchResult);
            // update this's result from search list
            this.searchResult.update(result);
            // now update result from visit/load (includes answers)
            const visitData: IVisit = await ApiClient.get(`api/visit/Load?id=${this.searchResult.visit.id}`);
            this.searchResult.visit.update(visitData);
            this.shouldShowDialogue = true;
        }

        confirmDelete(): void {
            const dialog: ConfirmDialogue = this.$refs.deleteDialogue as ConfirmDialogue;
            dialog.show();
        }

        print(): void {

            const url = `/Admin/visitPrint/${this.searchResult.visit.id}`;
            const printWindow = window.open(url);
            if(printWindow == null) {
                alert("Failed to open pop-up print window.  Do you have a pop-up blocker?");
                return;
            }
            //Close window once print is finished
            printWindow.onafterprint = () =>{
                printWindow.close();
            };

        }

        //

        confirmSend(): void {
            const isCompleted = Utils.hasDateValue(this.searchResult.visit.completed);
            const dialog: ConfirmDialogue = this.$refs.sendDialogue as ConfirmDialogue;
            dialog.title = isCompleted
                ? "Re-send Results"
                : "Re-send Link"
            dialog.text = `Send email to <b>${this.searchResult.visit.email}</b> now?`;
            dialog.show();
        }

        async doDelete(): Promise<void> {
            await ApiClient.post("/api/visit/delete", this.searchResult.visit, "visit-delete");
            toastr.warning("Deleted");
            this.$emit("saved");
            this.shouldShowDialogue = false;
        }

        async doSend(): Promise<void> {
            await ApiClient.get("/api/visit/resend?visitID=" + this.searchResult.visit.id, "visit-send");
            toastr.info("Sent");
            this.shouldShowDialogue = false;
        }
    }
